import MatrixGallery_MatrixGalleryTextSlideUpSkinComponent from '../components/NativeGalleries/MatrixGallery/viewer/skinComps/MatrixGalleryTextSlideUpSkin/MatrixGalleryTextSlideUpSkin.skin';
import MatrixGallery_MatrixGalleryTextSlideUpSkinController from '../components/NativeGalleries/MatrixGallery/viewer/MatrixGallery.controller';


const MatrixGallery_MatrixGalleryTextSlideUpSkin = {
  component: MatrixGallery_MatrixGalleryTextSlideUpSkinComponent,
  controller: MatrixGallery_MatrixGalleryTextSlideUpSkinController
};


export const components = {
  ['MatrixGallery_MatrixGalleryTextSlideUpSkin']: MatrixGallery_MatrixGalleryTextSlideUpSkin
};

